import React, { useRef } from "react";
import CopyIcon from "../../../../assets/profile/icons/copy.svg";
import DownloadIcon from "../../../../assets/profile/icons/download.svg";
import { QRCodeSVG } from "qrcode.react";
import { copyQRCodeToClipboard, downloadQRCode } from "../../utils/QRCodeUtil";
import { useAppDispatch } from "../../../../store/store";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

export const QRCodeContainer = ({ linkValue }: { linkValue: string }) => {
  const { t } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();
  const qrCodeRef = useRef<SVGSVGElement>(null);

  const maxWidth1090px = useMediaQuery("(max-width: 1090px)");
  const maxWidth720px = useMediaQuery("(max-width: 720px)");

  return (
    <div className="qr-code-container">
      {maxWidth720px && (
        <div className="qr-code-title-wrapper">{t("qr_code")}</div>
      )}

      <div className="qr-code-wrapper">
        <div className="qr-code-svg-wrapper">
          <QRCodeSVG
            ref={qrCodeRef}
            value={linkValue}
            size={maxWidth720px ? 100 : maxWidth1090px ? 67 : 76}
            level="M"
            bgColor="#FFFFFF"
            fgColor="#000000"
          />
        </div>

        <div className="qr-code-download-icon-wrapper">
          <img
            src={CopyIcon}
            onClick={() => copyQRCodeToClipboard(qrCodeRef, dispatch)}
            alt="Copy QR code"
            style={{
              cursor: "pointer",
            }}
          />
          <img
            src={DownloadIcon}
            onClick={() => downloadQRCode(qrCodeRef)}
            alt="Download QR code"
            style={{
              cursor: "pointer",
            }}
          />
        </div>
      </div>
    </div>
  );
};
